<div class="unclaimed-toolbar" data-cy="my-unclaimed-tasks">
	<div class="unclaimed-toolbar-copy">
		<div class="unclaimed-toolbar-title">
			Select tasks to claim
		</div>

		<div
			*ngIf="selectedTasks.length > 0"
			class="unclaimed-toolbar-selection"
		>
			{{ selectedTasks.length }}
			{{ selectedTasks.length === 1 ? 'task selected' : 'tasks selected' }}
		</div>
	</div>

	<button
		pButton
		type="button"
		icon="pi pi-check"
		label="Claim Selected"
		class="p-button-primary"
		[disabled]="selectedTasks.length === 0 || isClaiming"
		(click)="claimSelectedTasks()"
	></button>
</div>

<div *ngIf="isLoading" class="dashboard-state">
	<p-progressSpinner
		[style]="{ width: '28px', height: '28px' }"
		strokeWidth="4"
	></p-progressSpinner>

	<span>Loading unclaimed tasks...</span>
</div>

<div *ngIf="!isLoading && isClaiming" class="dashboard-state">
	<p-progressSpinner
		[style]="{ width: '28px', height: '28px' }"
		strokeWidth="4"
	></p-progressSpinner>

	<span>Claiming selected tasks...</span>
</div>

<div
	*ngIf="!isLoading && !isClaiming"
	class="unclaimed-table-wrapper"
>
	<p-table
		data-cy="unclaimed-tasks-table"
		[value]="unclaimedTasks"
		[(selection)]="selectedTasks"
		[paginator]="true"
		[rows]="20"
		[showCurrentPageReport]="true"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} records"
		dataKey="processId"
		selectionMode="multiple"
		styleClass="dashboard-data-table"
	>
		<ng-template pTemplate="header">
			<tr>
				<th class="selection-column">
					<p-tableHeaderCheckbox></p-tableHeaderCheckbox>
				</th>

				<th pSortableColumn="name">
					Task Name
					<p-sortIcon field="name"></p-sortIcon>
				</th>

				<th pSortableColumn="type">
					Type
					<p-sortIcon field="type"></p-sortIcon>
				</th>

				<th pSortableColumn="assignedDisplayName">
					Group Name
					<p-sortIcon field="assignedDisplayName"></p-sortIcon>
				</th>

				<th pSortableColumn="dueDate">
					Due Date
					<p-sortIcon field="dueDate"></p-sortIcon>
				</th>
			</tr>
		</ng-template>

		<ng-template pTemplate="body" let-task>
			<tr>
				<td class="selection-column">
					<p-tableCheckbox [value]="task"></p-tableCheckbox>
				</td>

				<td class="task-name">
					{{ task.name }}
				</td>

				<td>
					<span
						class="task-type"
						[ngClass]="getTaskClass(task.type)"
					>
						{{ handleTaskType(task.type) }}
					</span>
				</td>

				<td>
					{{ task.assignedDisplayName }}
				</td>

				<td class="due-date">
					{{ task.dueDate | DateLocalFormat: false }}
				</td>
			</tr>
		</ng-template>

		<ng-template pTemplate="emptymessage">
			<tr>
				<td colspan="5">
					<div class="dashboard-empty-state">
						<i class="pi pi-check-circle"></i>
						<span>No unclaimed tasks</span>
					</div>
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>
